import Web3 from "web3";
import { coerceStringZero } from "@/utils/utils.js";

const POOL_ID_TO_LEVEL = {
  v1: 1,
  v2: 2,
  v3: 3,
  v4: 4,
  v5: 5,
};

/** @param {"v1"|"v2"|"v3"|"v4"|"v5"} poolId */
export function poolIdToLevel(poolId) {
  return POOL_ID_TO_LEVEL[poolId] ?? null;
}

/**
 * 解析 get_pool_user_num 响应 data：{ "1": n1, "2": n2, ... "5": n5 }
 * @returns {string[]} V1～V5 人数字符串
 */
export function parsePoolUserNums(data) {
  if (data == null || typeof data !== "object") {
    return ["0", "0", "0", "0", "0"];
  }
  return [1, 2, 3, 4, 5].map((k) =>
    String(coerceStringZero(data[String(k)] ?? 0))
  );
}

/**
 * 解析 get_level_address 响应 data：钱包地址字符串数组
 * @returns {string[]} checksum 地址列表
 */
export function parseLevelAddressList(data) {
  if (!Array.isArray(data)) {
    throw new Error("奖金池地址接口返回数据无效");
  }
  const out = [];
  for (const item of data) {
    const s = String(item || "").trim();
    if (!Web3.utils.isAddress(s)) {
      throw new Error(`奖金池地址列表包含无效地址: ${s || "(空)"}`);
    }
    out.push(Web3.utils.toChecksumAddress(s));
  }
  if (!out.length) {
    throw new Error("该级别暂无用户，无法分配");
  }
  return out;
}
